<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon style="vertical-align: middle;">gavel</mat-icon>
				<span>{{ environment.texts.legalArea.label }}</span>
			</div>

			@if( bLoading ) {
				<mat-spinner diameter=30 />
			}

		</div>

		@if( bLoading ) {
			<!-- the spinner is shown above -->
		}
		@else if( bErrorLoading ) {
			<div class="errorWarning">
				Beim Laden der Daten ist ein Fehler aufgetreten
			</div>
		}
		@else {

			<div class="accFilterAndAccordeon" style="width: 100%;">
	
				<div class="accAccordeon">
						
					<legal-document-editor
						legalType="datenschutz"
						title="Datenschutzbestimmungen"
						[originalText]="originalPrivacyPolicyHtml"
					/>

					<legal-document-editor
						legalType="datenschutz-chat"
						title="Datenschutzbestimmungen für den Chat"
						[originalText]="originalPrivacyPolicyChatHtml"
					/>

					<legal-document-editor
						legalType="impressum"
						title="Impressum"
						[originalText]="originalImprintHtml"
					/>

					<legal-document-editor
						legalType="kontakt"
						title="Kontaktinformationen"
						placeholder="Telefonnummer, email, etc."
						[originalText]="originalContactHtml"
					/>

					<legal-document-editor
						legalType="nutzungsbedingungen-chat"
						title="Nutzungsbedingungen für den Chat"
						[originalText]="originalTermsOfUseChatHtml"
					/>

					@if (environment.features.nutzungsbedingungen) {
						<legal-document-editor
							legalType="nutzungsbedingungen"
							title="Nutzungsbedingungen"
							[originalText]="originalTermsOfUseHtml"
						/>
					}

				</div>
	
			</div>

		}

	</div>

</div>